import React, { useContext } from 'react';
import './ProfileCardDigit.css';
import { defaultProfileImage } from '../DefaultImage';
import { CardContext } from '../../../store/CardContext';
import { Link } from "react-router-dom";
import { TbArrowsExchange } from "react-icons/tb";
import ExchangeContact from "../../Common/exchangeContactModal/ExchangeContact";
import { useQueryClient } from '@tanstack/react-query';
import { updateTapCount } from '../../../helpers/tapCountMutation';
function ProfileCardDigit({ card, Highlightcolor, Textcolor, preview, Iconcolor, BtIColor, profileCardColor, theme }) {
  const [cardData] = useContext(CardContext);
  const { profileImage, personalDetails, checkProfile, contactDetails, vCard } = cardData;

  const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";
  const headlines = card?.headlines;
  function isDarkColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  }
  const exchangeButton = (
    <button
      className="flex justify-center items-center text-[12px] p-2 gap-3 h-[45px] rounded-[6px] w-full"
      style={{
        border: `2px solid ${Highlightcolor || "black"}`,
        color: Highlightcolor || "black",
      }}
    >
      <TbArrowsExchange className="w-4 h-4" />
      Exchange Contacts
    </button>
  )

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  return (
    <div className='profileCardDigit flex flex-col  rounded-lg  max-w-[600px] shadow-lg'>
      <div className="flex flex-row items-center">
        {checkProfile && (
          <figure className="w-[40%] h-fit mr-4">
            {profileImage ? (
              <img src={profileImage} alt="Profile" className="" />
            ) : (
              <img src={defaultProfileImage} alt="Default Profile" className="" />
            )}
          </figure>
        )}
        <div
          className="flex w-[60%] flex-col justify-center text-left"
        //   style={{
        //     backgroundColor: profileCardColor || Highlightcolor || '',
        //   }}
        >
          <h1
            className='font-bold text-2xl'
            style={{
              color: profileCardColor ? "black" : Textcolor || "",
              fontSize: array[0]?.length > 12 || array[1]?.length > 12 || array[2]?.length > 12 ? "20px" : personalDetails?.nameSize ? `${personalDetails?.nameSize}px` : "24px",
            }}
          >
            {personalDetails?.name || ""}
          </h1>
          <p
            className='text-sm'
            style={{
              color: profileCardColor ? "black" : Textcolor || "",
              fontSize: personalDetails?.designationSize ? personalDetails?.designationSize + 'px' : "16px",
            }}
          >
            {personalDetails?.companyDesignation || ""}
          </p>
          {card?.about ? (
            <div>
          
              <div className="about text-[11px] whitespace-pre-line" style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>{card?.about}</div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="flex justify-between w-full mt-2 p-3 gap-2">
        <Link
          onClick={() => handleTap('saveContact')}
          to={`${preview ? vCard : ""}`}
          // target={`${preview ? "_blank" : ""}`}
          className="blk-btn w-1/2"
        >
          <button
            className="flex justify-center items-center p-2 text-[12px] gap-2 h-[45px] rounded-[6px] w-full"
            style={{
              background: Highlightcolor || "black",
            }}
          >
               <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 8C9.29493 8 10.75 6.54493 10.75 4.75C10.75 2.95507 9.29493 1.5 7.5 1.5C5.70507 1.5 4.25 2.95507 4.25 4.75C4.25 6.54493 5.70507 8 7.5 8Z"        stroke={isDarkColor(Highlightcolor) ? "white" : "black"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.68 14.5C13.2602 13.1908 12.4355 12.0488 11.3248 11.2386C10.2141 10.4284 8.8748 9.99182 7.5 9.99182C6.1252 9.99182 4.78591 10.4284 3.67522 11.2386C2.56453 12.0488 1.73982 13.1908 1.32 14.5H13.68Z" stroke={isDarkColor(Highlightcolor) ? "white" : "black"}  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            <span
              className="text-[12px]"
              style={{
                color: isDarkColor(Highlightcolor) ? "white" : "black",
              }}
            >
              Add to contacts
            </span>
          </button>
        </Link>
        {card?.exchangeContact?.show ?
          <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
          : ""
        }

      </div>
    </div>
  );
}

export default ProfileCardDigit;
